export const TEXT_SEARCH_DEBOUNCE_MS = 160;

export function searchDebounceMs(kind) {
  return kind === 'text' ? TEXT_SEARCH_DEBOUNCE_MS : 0;
}

export function beginLatestRequest(sequenceRef) {
  const requestId = Number(sequenceRef.current || 0) + 1;
  sequenceRef.current = requestId;
  return () => sequenceRef.current === requestId;
}

export function claimPendingScan(pendingScanRef, normalizedCode) {
  if (!normalizedCode || pendingScanRef.current !== normalizedCode) return false;
  pendingScanRef.current = '';
  return true;
}
